import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BiPieChart } from '@/features/dashboard-finance/charts/BiPieChart';
import { formatUsdCents } from '@/features/dashboard-finance/formatters';

const PALETTE = ['#2563eb', '#10b981', '#f97316', '#a855f7', '#ef4444'];

/** Pizza da receita direta mensal atual por plano, em USD eq. */
export function RevenueByPlanChart({
  byPlanUsdCents,
}: {
  byPlanUsdCents: Record<string, number>;
}): React.JSX.Element {
  const { t } = useTranslation();
  const data = Object.entries(byPlanUsdCents)
    .map(([plan, cents], i) => ({
      title: plan,
      value: cents / 100,
      color: PALETTE[i % PALETTE.length] ?? '#6b7280',
    }))
    .sort((a, b) => b.value - a.value);

  return (
    <BiPieChart
      title={t('sales.charts.revenueByPlan')}
      subtitle={t('sales.charts.revenueByPlanHint')}
      data={data}
      valueFormatter={(v): string => formatUsdCents(Math.round(v * 100))}
    />
  );
}
